export const PLATFORMS = {
  META_ADS: 'Meta Ads',
  GOOGLE_ADS: 'Google Ads',
  TIKTOK_ADS: 'TikTok Ads',
} as const;

export const REPORT_TYPES = {
  REACH_AND_FREQUENCY: 'Reach & Frequency',
  AGE_AND_GENDER: 'Age & Gender',
  DMA: 'DMA',
  SKU: 'SKU',
} as const;

export const CADENCES = {
  PRIOR_WEEK: 'Prior Week',
  PRIOR_MONTH: 'Prior Month',
  MONTH_TO_DATE: 'Month-to-date',
  SEVEN_DAYS_LOOKBACK: '7 Days Lookback',
  THIRTY_DAYS_LOOKBACK: '30 Days Lookback',
} as const;

export const METRIC_TYPES = {
  DELIVERY: 'Delivery',
  CONVERSIONS: 'Conversions',
} as const;

export const GRANULARITY_LEVELS = {
  CAMPAIGN: 'Campaign',
  AD_SET: 'Ad Set',
  AD: 'Ad',
} as const;

export const CONFIG_STATUS = {
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated',
} as const;

export const REPORT_TYPE_CATEGORIES = {
  /** Non-R&F types default to breakdown behavior (including SKU and future types). */
  BREAKDOWNS: ['Age & Gender', 'DMA', 'SKU'],
  REACH_AND_FREQUENCY: ['Reach & Frequency'],
} as const;

export const CADENCES_WITH_FISCAL_CALENDAR = ['Prior Month', 'Month-to-date'];

export const DEFAULT_GRANULARITY = 'Campaign';
export const DEFAULT_METRIC_TYPE = 'Delivery';

export const FISCAL_CALENDAR_WARNING = 
  "This brand doesn't have a fiscal calendar uploaded. Please follow the steps in the fiscal calendar documentation after submitting this request to make it available.";

export const FISCAL_CALENDAR_DOCS_URL = 
  "https://doc.clickup.com/d/h/8chky28-13911/51f87e66df5814a/8chky28-7551";

export const DUPLICATE_ERROR_MESSAGE = 
  "This configuration already exists for the selected brand. Please modify your selection or edit the existing configuration.";

export const DUPLICATE_DEACTIVATED_ERROR_MESSAGE =
  "This configuration already exists in a deactivated state. Please reactivate the existing configuration instead of creating a new one.";
